import windowStorageClearService from "@/services/window-storage-clear-service";

var StoreAuthenticationHandler = (function () {
    var initialize = function () { }

    var terminate = function () {
        windowStorageClearService.clearEverything();
    }

    return {
        initialize: initialize,
        terminate: terminate
    }
}());

export default StoreAuthenticationHandler;
